import Vue from 'vue'

const initialState = () => ({
  cachedRelations: {},
  cachedCustomObjs: {},
  isRequestPending: {},
})

export default {
  namespaced: true,

  state: initialState(),

  mutations: {
    RESET_STATE (state) {
      Object.assign(state, initialState())
    },
    SET_RELATIONS (state, { key, data }) {
      Vue.set(state.cachedRelations, key, data)
    },
    SET_CUSTOM_OBJS (state, { key, data }) {
      Vue.set(state.cachedCustomObjs, key, data)
    },
    SET_REQUEST_PENDING (state, { key, bool }) {
      Vue.set(state.isRequestPending, key, bool)
    }
  },

  getters: {
    cachedRelations: state => state.cachedRelations,
    cachedCustomObjs: state => state.cachedCustomObjs,
    isRequestPending: state => state.isRequestPending,
  }
}



// WEBPACK FOOTER //
// ./src/stores/cache-metafields.js